import styled from '@emotion/styled';
import { xcss } from '@atlaskit/primitives';
import { InvoiceGroup } from '@css-xp/graphtypes';
import { Maybe } from '@css-xp/graphtypes/src/generated-types-new';

export const getBoxStyles = (
  selected: InvoiceGroup | null | undefined,
  id: Maybe<string> | undefined,
  isTextDisabled: boolean
) =>
  xcss({
    backgroundColor: 'elevation.surface',
    borderColor: selected?.id === id ? 'color.border.selected' : 'color.border',
    borderWidth: selected?.id === id ? 'border.width.outline' : 'border.width',
    borderStyle: 'solid',
    borderRadius: 'border.radius.200',
    minHeight: '150px',
    padding: 'space.200',
    display: 'flex',
    flexDirection: 'column',
    gap: isTextDisabled ? 'space.100' : 'space.150',
  });

export const BillingProfileCardContainer = styled.div(({ isTextDisabled }: { isTextDisabled: boolean }) => {
  return {
    '&:hover': {
      cursor: isTextDisabled ? 'not-allowed' : 'pointer',
    },
    '.text-ellipsis': {
      maxWidth: '220px',
    },
  };
});
